import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, DetachedRouteHandle, RouteReuseStrategy} from '@angular/router';
//force component refresh when navigating from one dealID to another
@Injectable()
export class ParamAwareReuseStrategy implements RouteReuseStrategy {
    shouldDetach(_route: ActivatedRouteSnapshot): boolean { return false; }
    store(_route: ActivatedRouteSnapshot, _handle: DetachedRouteHandle | null): void {}
    shouldAttach(_route: ActivatedRouteSnapshot): boolean { return false; }
    retrieve(_route: ActivatedRouteSnapshot): DetachedRouteHandle | null { return null; }

    shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
        const sameConfig = future.routeConfig === curr.routeConfig;
        if (!sameConfig) {
            return false;
        }

        const fp = future.params, cp = curr.params;
        return Object.keys(fp).length === Object.keys(cp).length &&
            Object.keys(fp).every(k => fp[k] === cp[k]);
    }
}
